import { createAction, props } from '@ngrx/store';

export const setNavigationEnd = createAction('[Router] Navigation End', props<{ routerEvent: any }>());

export const setCurNavigation = createAction('[Router] Current Page', props<{ curPage: any }>());

export const setCurPage = createAction('[Router] SelectedPage Page', props<{ currentPage: any }>());
